import { AssignmentPapers } from './subcomponents/AssignmentPapers';
import { BsPencil, BsPlusCircle } from 'react-icons/bs';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { FailedToGetData, H2, HorizontalSelector, Hr, Loading } from 'src/components/_commons';
import { generalHelpers } from '@monorepo/helpers';
import { helpers, meetingServices, userServices } from 'src/services';
import { Meeting } from '../_commons/Meeting';
import { MidweekMeetingsCrud } from './subcomponents/MidweekMeetingsCrud';
import { setAlertResponse } from 'src/store';
import { typeMeeting, typeMeetingsDoc, typeUser } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { useGetIsDarkMode } from 'src/custom-hooks';

export const AdminsMidweekMeetings = () => {
    const [isLoading1, setIsLoading1] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [meetingsDoc, setMeetingsDoc] = useState<typeMeetingsDoc | null>(null);
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [showCrud, setShowCrud] = useState(false);
    const [showPapers, setShowPapers] = useState(false);
    const [users, setUsers] = useState<typeUser[] | null>(null);
    const [weekNumber, setWeekNumber] = useState(generalHelpers.GetCalendarWeekNumber(new Date()));
    const [year, setYear] = useState(new Date().getFullYear());
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    const midweekMeeting: typeMeeting | null = useMemo(() =>
        meetingsDoc?.midweeks?.find(m => m.year === year && m.weekNumber === weekNumber) ?? null
    , [meetingsDoc, weekNumber, year]);

    useEffect(() => {
        meetingServices.Get().then(response => {
            setIsLoading1(false);
            if (!response.success || !response.data?.meetingsDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setMeetingsDoc(response.data.meetingsDoc);
        });
    }, [refreshCounter]);

    useEffect(() => {
        userServices.GetAll().then(response => {
            setIsLoading2(false);
            if (!response.success || !response.data?.users) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setUsers(response.data.users);
        });
    }, [refreshCounter]);

    if (isLoading1 || isLoading2) {
        return <Loading mt={'80px'} />;
    }

    if (!meetingsDoc || !users) {
        return <FailedToGetData />;
    }

    return (
        <>
        {showPapers &&
            <AssignmentPapers
                closeModal={() => setShowPapers(false)}
            />
        }
        <H2 title={'REUNIONES VIDA Y MINISTERIO'} />
        <div>
            {!showCrud ?
                <>
                <div className={'d-flex justify-content-center mb-4'}>
                    <button className={'btn btn-general-blue'} onClick={() => setShowPapers(true)}>
                        <FaExternalLinkAlt className={'mb-1 me-2'} />Usar el Generador de Papeles de Asignación
                    </button>
                </div>
                <div className={'mb-4'}>
                    <Hr />
                </div>
                <HorizontalSelector
                    label={`Semana ${weekNumber} de ${year}`}
                    label1={`${helpers.GetCalendarWeekRange(weekNumber, year).minDateStr} al ${helpers.GetCalendarWeekRange(weekNumber, year).maxDateStr}`}
                    setPrevious={() => {
                        if (weekNumber === 1) {
                            const weeksInPreviousYear = generalHelpers.GetCalendarWeekCount(year - 1);  // 52-53 weeks
                            setWeekNumber(weeksInPreviousYear);
                            setYear(x => x - 1);
                        } else {
                            setWeekNumber(x => x - 1);
                        }
                    }}
                    setNext={() => {
                        const weeksInCurrentYear = generalHelpers.GetCalendarWeekCount(year);  // 52-53 weeks
                        if (weekNumber === weeksInCurrentYear) {
                            setWeekNumber(1);
                            setYear(x => x + 1);
                        } else {
                            setWeekNumber(x => x + 1);
                        }
                    }}
                />
                {!!midweekMeeting?.sections.length ?
                    <>
                    <div className={'d-flex justify-content-center mt-4'}>
                        <button className={'btn btn-general-blue'} onClick={() => setShowCrud(true)}>
                            <BsPencil className={'mb-1 me-2'} />Editar Reunión
                        </button>
                    </div>
                    <div className={`${isDarkMode ? 'bg-lightdark text-white' : ''} mt-5`}>
                        <Meeting
                            meeting={midweekMeeting}
                            meetingsDoc={meetingsDoc}
                            readOnly
                            setMeeting={() => {}}
                            type={'midweek'}
                            users={users}
                            weekNumber={weekNumber}
                            year={year}
                        />
                    </div>
                    </>
                    :
                    <div className={'d-flex justify-content-center mt-4'}>
                        <button className={'btn btn-general-blue'} onClick={() => setShowCrud(true)}>
                            <BsPlusCircle className={'mb-1 me-2'} />Crear Reunión
                        </button>
                    </div>
                }
                </>
                :
                <>
                <MidweekMeetingsCrud
                    closeCrud={() => {
                        setShowCrud(false);
                        setRefreshCounter(x => x + 1);
                        helpers.GoToTop();
                    }}
                    meetingsDoc={meetingsDoc}
                    meetingToEdit={midweekMeeting}
                    users={users}
                    weekNumber={weekNumber}
                    year={year}
                />
                </>
            }
        </div>
        </>
    );
}
